import { OnDestroy, OnInit, Component } from '@angular/core';
import { ValidatorService } from 'app/shared/services/validator.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { IDtoHoliday } from 'app/shared/models/request/holiday/dto-holiday.model';
import { HolidayService } from 'app/views/appviews/request/holiday.service';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-modal-reason-cancel',
  styleUrls: ['modal-reason-cancel.style.scss'],
  templateUrl: 'modal-reason-cancel.template.html'
})
export class ModalReasonCancelComponent implements OnDestroy, OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private flag = false;
  private errorMessages: any;
  /**Formularios */
  private formReasonCancel: FormGroup;
  /**Retorno a pantalla padre */
  public onClose: Subject<boolean>;
  private request: IDtoHoliday;
  constructor(private formBuilder: FormBuilder
    , private configGeneral: AppConfig
    , private bsModalRef: BsModalRef
    , private holidayService: HolidayService
    , private identityService: IdentityService
    , private spinner: NgxSpinnerService) {
    this.initializeFormReasonCancel();
  }
  ngOnDestroy(): void {
  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }
  private initializeFormReasonCancel() {
    this.formReasonCancel = this.formBuilder.group({
      reasonCancel: [null, [Validators.required, Validators.maxLength(250)]]
    });
  }
  private submitForm(): void {
    if (this.formReasonCancel.valid) {
      this.update();
    } else {
      this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
    }
  }
  private update(): void {
    this.spinner.show();
    this.request.status = 3;
    this.request.cancelComments = this.formReasonCancel.value.reasonCancel;
    this.holidayService.updateHoliday(this.request)
      .subscribe(
        (x) => {
          if (this.configGeneral.notificationSuccessError(x)) {
            this.addModuleLog(this.request.id);
            this.onClose.next(true);
          } else {
            this.onClose.next(false);
          }
          this.bsModalRef.hide();
          this.spinner.hide();
        },
        (errMessage) => this.errorMessages = errMessage.messages);
  }
  private onCancel(): void {
    this.bsModalRef.hide();
  }
  private addModuleLog(id: number): void {
    let dto = {} as IDtoModuleLog;
    dto.table = 'Holidays';
    dto.module = 'holidayApproval';
    dto.action = 'cancelled';
    dto.registryAffectedId = id;
    this.identityService.addModuleLog(dto).subscribe(
      (x) => { });
  }
}
